<template>
  <div>
    <VueMultiselect
      v-model="modelValue"
      :options="options"
      noOptionsText="Nenhum resultado encontrado!"
      noResultsText="Nenhum resultado encontrado!"
      placeholder=""
      :disabled="disabled"
      :searchable="true"
      :label="slugDesc"
      :trackBy="slugDesc"
      :valueProp="slugId"
      :value="slugDesc"
      @input="onChangeCombo"
      :required="required"
    >
    </VueMultiselect>
  </div>
</template>

<script>
import service from '@/services/BaseService'

export default {
  name: 'Multiselect',
  props: {
    slugId: { type: String },
    slugDesc: { type: String },
    endpoint: { type: String },
    required: { type: Boolean, default: false },
    model: { type: Number },
    disabled: { type: Boolean, default: false },
  },
  data() {
    return {
      modelValue: this.model,
      options: [],
    }
  },
  created() {
    this.getItens()
  },
  methods: {
    onChangeCombo(value) {
      this.$emit('onChangeCombo', value)
    },
    async getItens() {
      var http = new service(this.endpoint)
      await http
        .find()
        .then((resp) => {
          this.options = resp.data.response
          this.key++
        })
        .catch(() => {})
    },
  },
}
</script>
